import { render, staticRenderFns } from "./KoioteValueLabel.vue?vue&type=template&id=330d7f1f&scoped=true"
import script from "./KoioteValueLabel.vue?vue&type=script&lang=js"
export * from "./KoioteValueLabel.vue?vue&type=script&lang=js"
import style0 from "./KoioteValueLabel.vue?vue&type=style&index=0&id=330d7f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d7f1f",
  null
  
)

export default component.exports